(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sa-product-card"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sa-catalog-card')) {
    customElements.define(
      'sa-catalog-card',
      class SaCatalogCard extends HTMLElement {
        connectedCallback() {
          if (this._bound) return;
          this._bound = true;
          this._onClick = this.onClick.bind(this);
          this.addEventListener('click', this._onClick);
        }

        disconnectedCallback() {
          this.removeEventListener('click', this._onClick);
          this._bound = false;
        }

        onClick(event) {
          if (window.__saCatalogCardSwatchBound) return;
          const swatch = event.target.closest('[data-sa-card-swatch]');
          if (!swatch || !this.contains(swatch)) return;
          if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

          event.preventDefault();
          event.stopPropagation();

          let data;
          try {
            data = JSON.parse(swatch.getAttribute('data-sa-card-swatch'));
          } catch (error) {
            return;
          }

          this.applyVariant(data);
          this.querySelectorAll('[data-sa-card-swatch]').forEach((item) => {
            item.removeAttribute('aria-current');
          });
          swatch.setAttribute('aria-current', 'page');
          swatch.blur();
        }

        applyVariant(data) {
          const image = this.querySelector('.sa-product-card__media');
          if (image && data.image) {
            image.src = data.image;
            if (data.srcset) image.srcset = data.srcset;
          }

          this.querySelectorAll('[data-sa-card-link]').forEach((link) => {
            if (data.url) link.setAttribute('href', data.url);
          });

          const price = this.querySelector('[data-sa-card-price]');
          if (price && data.price) {
            const template = document.createElement('template');
            template.innerHTML = data.price;
            price.textContent = (template.content.textContent || data.price).trim();
          }

          const saleBadge = this.querySelector('[data-sa-card-sale-badge]');
          if (saleBadge) saleBadge.classList.toggle('is-hidden', !data.sale);

          const soldBadge = this.querySelector('[data-sa-card-sold-badge]');
          if (soldBadge) soldBadge.classList.toggle('is-hidden', !data.sold);

          const cart = this.querySelector('[data-sa-card-cart]');
          const cartButton = this.querySelector('[data-sa-card-cart-button]');
          if (cart && data.variantId) cart.setAttribute('data-variant-id', data.variantId);
          if (cartButton) {
            if (data.available) cartButton.removeAttribute('disabled');
            else cartButton.setAttribute('disabled', '');
          }
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
